import AuthenticationService from "service/auth/AuthenticationService";
import EnvironmentService from "service/environment/EnvironmentService";
import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

class BankAccountService {
  constructor() {
    this.authenticationService = new AuthenticationService();
    this.environmentService = new EnvironmentService();
    this.apiService = new APIService();
  }

  fetchMaskedPrimaryBankAccountForPatient(pId, onResponse, onError) {
    let url =
      APIConfig.bankAccount.fetchMaskedPrimaryBankAccountForPatient.format(pId);
    return this.apiService.get(url, onResponse, onError);
  }

  fetchMaskedBankAccountForPatient(pId, accId, onResponse, onError) {
    let url = APIConfig.bankAccount.fetchMaskedBankAccountForPatient.format(
      pId,
      accId
    );
    return this.apiService.get(url, onResponse, onError);
  }

  fetchChequeFile(accId, onResponse, onError) {
    let url = APIConfig.bankAccount.fetchChequeFile.format(accId);
    return this.apiService.getFileStream(url, onResponse, onError);
  }

  fetchMaskedBankAccountById(pId, onResponse, onError) {
    let url = APIConfig.bankAccount.fetchMaskedBankAccountById.format(pId);
    return this.apiService.get(url, onResponse, onError);
  }

  fetchFullBankAccountById(accId, onResponse, onError) {
    let url = APIConfig.bankAccount.fetchFullBankAccountById.format(accId);
    return this.apiService.get(url, onResponse, onError);
  }

  fetchIFSCDetails(ifsc, onResponse, onError) {
    let url = APIConfig.bankAccount.fetchIFSCDetails.format(ifsc);
    return this.apiService.get(url, onResponse, onError);
  }

  addBankAccount(params, onResponse, onError) {
    let url = APIConfig.bankAccount.addBankAccount;
    return this.apiService.postWithFormData(url, params, onResponse, onError);
  }

  updateBankAccount(body, onResponse, onError) {
    let url = APIConfig.bankAccount.updateBankAccount;
    return this.apiService.put(url, body, onResponse, onError);
  }
}

export default BankAccountService;
